if (!customElements.get('header-tabs')) {
  class HeaderTabs extends HTMLElement {
    static selectors = {
      aside: '[js-tabs-aside]',
      link: '[js-tab-link]',
      tab: '[js-tab-item]',
      active: '.is-active',
    };

    static attributes = {
      link: 'js-tab-link',
    };
    static ACTIVE_CLASS = 'is-active';

    constructor() {
      super();
    }

    /**
     * Handles a click event on the tabs aside element.
     * - Finds the clicked tab link element and its corresponding tab content element.
     * - Removes the active class from all currently active tab links and tab content elements.
     * - Adds the active class to the clicked tab link and its corresponding tab content element.
     * - Prevents the default link behavior to allow for client-side tab switching.
     *
     * @param {Event} event - The click event object.
     */
    handleClick(event) {
      const target = event.target.closest('a');
      if (!target || !target.hasAttribute(HeaderTabs.attributes.link)) return;

      const targetHref = target.getAttribute('href');
      const targetTab = this.querySelector(targetHref);

      if (!targetTab) return;

      event.preventDefault();

      this.querySelectorAll(HeaderTabs.selectors.active).forEach((el) => {
        el.classList.remove(HeaderTabs.ACTIVE_CLASS);
        if (el.hasAttribute(HeaderTabs.attributes.link)) {
          el.setAttribute('aria-selected', 'false');
        }
      });

      target.classList.add(HeaderTabs.ACTIVE_CLASS);
      target.setAttribute('aria-selected', 'true');
      targetTab.classList.add(HeaderTabs.ACTIVE_CLASS);
    }

    connectedCallback() {
      this.aside = this.querySelector(HeaderTabs.selectors.aside);

      this.aside.addEventListener('click', this.handleClick.bind(this));
      this.aside.addEventListener('mouseover', this.handleClick.bind(this));
    }
  }

  customElements.define('header-tabs', HeaderTabs);
}
